import { USER_ROLES } from 'Utils/Consts';
import { firestore } from './firebase';

const {
  OWNER, VIEWER, DELEGATE, MEMBER,
} = USER_ROLES;

const roles = [OWNER, VIEWER, DELEGATE, MEMBER];

const TemplatesCollection = firestore.collection('templates');

export const upsertTemplate = async (templateId, templateFragment, merge = true) => templateId
  ? TemplatesCollection.doc(templateId).set(templateFragment, { merge })
  : TemplatesCollection.doc().set(templateFragment);

export const getTemplateById = async (templateId) => TemplatesCollection.doc(templateId).get()
  .then((doc) => {
    if (doc.exists) {
      const data = doc.data();
      return data;
    }
  });

export const subscribeGroupTemplates = (groupId, cb) => {
  if (!groupId) return;
  const templatesRef = TemplatesCollection.where('groupId', '==', groupId);
  return new Promise((resolve, reject) => {
    const unsubscribe = templatesRef.onSnapshot(
      (docs) => {
        const data = {};
        docs.forEach((doc) => {
          data[doc.id] = { ...doc.data(), id: doc.id };
        });
        if (cb) cb({ data, unsubscribe });
        return resolve({ data, unsubscribe });
      },
      (err) => {
        console.log('Error getting templates by groupId', err);
        reject();
      },
    );
  });
};

export const subscribeMyTemplates = (uid, cb) => {
  if (!uid) return;
  const templatesRef = TemplatesCollection.where(`users.${uid}.roles`, 'array-contains-any', roles);
  return new Promise((resolve, reject) => {
    const unsubscribe = templatesRef.onSnapshot(
      (docs) => {
        const data = {};
        docs.forEach((doc) => {
          data[doc.id] = { ...doc.data(), id: doc.id };
        });
        if (cb) cb({ data, unsubscribe });
        return resolve({ data, unsubscribe });
      },
      (err) => {
        console.log('Error getting my templates', err);
        reject();
      },
    );
  });
};
